function formatFileLine(file: string, line?: string) {
    if (!file) {
        return null;
    }

    if (line !== null) {
        return `${file}:${line}`;
    }

    return file;
}

export default formatFileLine;
